import type { VariantDescription } from '@/variants'

export const orgSettingsTabsFor = (
  variant: Pick<VariantDescription, 'anleitung'>,
): readonly string[] => ['organisation', ...(variant.anleitung ? ['anleitung'] : [])]
